import Invoice from "@/assets/icons/sidebar/Invoice";
import SubAccount from "@/assets/icons/sidebar/SubAccount";
import Project from "@/assets/icons/sidebar/Project";
import Coupons from "@/assets/icons/sidebar/Coupons";
import Coin from "@/assets/icons/sidebar/Coin";
import Authorization from "@/assets/icons/sidebar/Authorization";
import Developer from "@/assets/icons/sidebar/Developer";
import InviteRewards from "@/assets/icons/sidebar/InviteRewards";
import BasicInfo from "@/assets/icons/sidebar/BasicInfo";
import Export from "@/assets/icons/sidebar/Export";
import Billings from "@/assets/icons/sidebar/Billings";
import Operation from "@/assets/icons/sidebar/Operation";
import Charge from "@/assets/icons/sidebar/Charge";
import Hot from "@/assets/icons/sidebar/Hot";
import { useTranslation } from "react-i18next";
import { InvoiceHeaderExtra } from "@/components/Sidebar/header-extra/invoice-header-extra";
import { ReactNode } from "react";
import { useGlobalStore } from "@/store/GlobalStore";
import { PictureList } from "project-config/constants";

export interface ISideItem {
  name: string;
  logo?: JSX.Element;
  path?: string;
  hidden?: boolean;
  childrenPath?: Array<string>;
  headerExtra?: ReactNode;
  sufIcon?: JSX.Element;
}

export function useGetSideList(): ISideItem[] {
  const { t } = useTranslation("sidebar");
  const { t: centerT } = useTranslation("center");
  const { isSubAccount, isForeign, userInfo, isDomestic, is88StudioUser } =
    useGlobalStore();
  return [
    {
      name: t("BaseInfo"),
      logo: <BasicInfo />,
      path: "/profile",
      // childrenPath: ["/topUp"],
    },
    {
      name: centerT("user_com_childManage"),
      logo: <SubAccount />,
      path: "/childCustomer",
      hidden: isSubAccount,
    },
    {
      name: centerT("header_user_tool_project"),
      logo: <Project />,
      path: "/project",
      hidden: PictureList.includes(userInfo?.platform as number),
    },
    { name: t("Coupon"), logo: <Coupons />, path: "/coupon" },
    {
      name: t("desktop"),
      logo: <Coin />,
      path: "/desktop",
      hidden: !userInfo?.enableRemoteDesktop,
    },
    {
      name: centerT("recharge_log"),
      logo: <Charge />,
      path: "/payment",
      hidden: Boolean(userInfo?.hideBalance),
    },
    {
      name: centerT("user_consume_list"),
      logo: <Billings />,
      path: "/consumption",
      childrenPath: ["/consumption/previous"],
      hidden:
        Boolean(userInfo?.hideJobCharge) && !(is88StudioUser && isSubAccount), // 88studio子账号是否可见消费账单不受权限控制
    },
    {
      name: t("InvoiceManage"),
      logo: <Invoice />,
      path: "/invoice",
      childrenPath: ["/invoice/previous"],
      headerExtra: <InvoiceHeaderExtra />,
      hidden: isForeign || isSubAccount,
    },
    { name: t("ExportRecord"), logo: <Export />, path: "/exportList" },
    { name: t("OperateRecord"), logo: <Operation />, path: "/operateRecord" },
    {
      name: t("PermissionManage"),
      logo: <Authorization />,
      path: "/authorization",
      hidden: isSubAccount,
    },
    { name: t("DeveloperCenter"), logo: <Developer />, path: "/developer" },
    {
      name: t("InviteRewards"),
      logo: <InviteRewards />,
      path: "/inviteRewards",
      hidden: !isDomestic || isSubAccount,
      sufIcon: <Hot />,
    },
    { name: "立即充值", path: "/topUp", hidden: true },
    {
      name: centerT("message_notice"),
      path: "/message/center",
      hidden: true,
    },
  ];
}
